module.exports = __webpack_public_path__ + "img/couponTitle.20c45158.png";